// External libraries
import styled from '@emotion/styled';

// Internal modules
import { ERROR_COLOR, getWordBreak } from '@/styles';

export const InlineFieldsContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 50%;
`;

export const RadioButtonsContainer = styled.div`
  margin-bottom: 18px;
  margin-top: 24px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  margin: 6px 0 12px;
  padding: 0 4px;
`;

export const ErrorMessage = styled.p`
  color: ${ERROR_COLOR};
  font-size: 15px;
  line-height: 1.35;
  margin-left: 6px;
  ${'' /* 27px ==> 9px margin-left + 18px width of <ErrorIcon /> */}
  ${getWordBreak('27px')}
`;
